// ═══════════════════════════════════════════════════════════════
// UTILITIES
// ═══════════════════════════════════════════════════════════════
export function formatBytes(bytes) {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / 1048576).toFixed(1) + " MB";
}

export function formatDuration(seconds) {
  if (!seconds) return "";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

const ACCEPTED_TYPES = {
  image: "image/png,image/jpeg,image/gif,image/webp,image/svg+xml,image/bmp",
  video: "video/mp4,video/webm,video/ogg,video/quicktime",
  pdf: "application/pdf",
};
export const ALL_ACCEPTED = Object.values(ACCEPTED_TYPES).join(",");

